<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item  v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>mcash{{$t('yhgl')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('yhrzxx')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <h2 style="margin-top:5px;">{{$t('yhdh')}}:{{phone}}</h2>
            <div class="formbox" style="width:700px;">
                <el-form ref="form" :model="form" label-width="150px">
                    <el-form-item :label="$t('fullName')">
                        <el-input v-model="form.fullName" style="width:400px;" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('fatherLastName')" style="margin-left: 550px;margin-top: -62px;">
                        <el-input v-model="form.fatherLastName" style="width:400px;" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('motherLastName')">
                        <el-input v-model="form.motherLastName" style="width:400px;" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('idNumber')" style="margin-left: 550px;margin-top: -62px;">
                        <el-input v-model="form.idNumber" style="width:400px;" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('gender')">
                        <el-input v-model="form.gender" style="width:400px;" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('email')" style="margin-left: 550px;margin-top: -62px;">
                        <el-input v-model="form.email" style="width:400px;" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('birthday')">
                        <el-input v-model="form.birthday" style="width:400px;" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('postalCode')" style="margin-left: 550px;margin-top: -62px;">
                        <el-input v-model="form.postalCode" style="width:400px;" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('district')">
                        <el-input v-model="form.district" style="width:400px;" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('addressAll')" style="margin-left: 550px;margin-top: -62px;">
                        <el-input v-model="form.addressAll" style="width:400px;" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('educationName')">
                        <el-input v-model="form.educationName" style="width:400px;" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('employmentName')" style="margin-left: 550px;margin-top: -62px;">
                        <el-input v-model="form.employmentName" style="width:400px;" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('comoanyName')">
                        <el-input v-model="form.comoanyName" style="width:400px;" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('comoanyPhone')" style="margin-left: 550px;margin-top: -62px;">
                        <el-input v-model="form.comoanyPhone" style="width:400px;" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('workingYearName')">
                        <el-input v-model="form.workingYearName" style="width:400px;" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('monthlySalaryName')" style="margin-left: 550px;margin-top: -62px;">
                        <el-input v-model="form.monthlySalaryName" style="width:400px;" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('workingDaysName')">
                        <el-input v-model="form.workingDaysName" style="width:400px;" :disabled="true"></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('idCardPositive')">
                        <div class="block">
                            <el-image :src="form.idCardPositive">
                            <div slot="placeholder" class="image-slot">
                                {{$t('jzz')}}<span class="dot">...</span>
                            </div>
                            </el-image>
                        </div>
                    </el-form-item>
                    <el-form-item :label="$t('idCardReverse')">
                        <div class="block">
                            <el-image :src="form.idCardReverse">
                            <div slot="placeholder" class="image-slot">
                                {{$t('jzz')}}<span class="dot">...</span>
                            </div>
                            </el-image>
                        </div>
                        <!-- <upload-imgbatch v-if="isloaded" :yuanlist="form.idCardReverse" @changeurl="getimgurl"></upload-imgbatch> -->
                    </el-form-item>
                    <el-form-item :label="$t('faceUrl')">
                        <div class="block">
                            <el-image :src="form.faceUrl">
                            <div slot="placeholder" class="image-slot">
                                {{$t('jzz')}}<span class="dot">...</span>
                            </div>
                            </el-image>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import apiurl from "@/api/public"
import _api from "@/api/index"
export default {
    data(){
        return{
            isloaded:false,    
            status:1,
            phone:"",
            form:{
                birthday:null,
                addressAll:null,
                gender:null,
                fatherLastName:null,
                motherLastName:null,
                postalCode:null,
                fullName:null,
                idNumber:null,
                district:null,
                email:null,

                educationName:null,
                employmentName:null,
                comoanyName:null,
                comoanyPhone:null,
                workingYearName:null,
                monthlySalaryName:null,
                workingDaysName:null,

                idCardPositive:null,
                idCardReverse:null,
                faceUrl:null
            },
            srcList: [
                'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
            ]

        }
    },
    created(){
        this.user=JSON.parse(localStorage.getItem("userinfo"))
        this.form.id=this.$route.query.id
        this.phone=this.$route.query.phone
        this.getDetail()
    },
    methods:{
        getDetail(){
            this.isloaded=false
            _api.get(apiurl.userInfo,{userId:this.form.id}).then(res=>{
                this.status=2
                this.form.birthday=res.data.birthday
                this.form.addressAll=res.data.addressAll
                this.form.gender=res.data.gender
                this.form.fatherLastName=res.data.fatherLastName
                this.form.motherLastName=res.data.motherLastName
                this.form.postalCode=res.data.postalCode
                this.form.fullName=res.data.fullName
                this.form.idNumber=res.data.idNumber
                this.form.district=res.data.district
                this.form.email=res.data.email

                this.form.educationName=res.data.educationName
                this.form.employmentName=res.data.employmentName
                this.form.comoanyName=res.data.comoanyName
                this.form.comoanyPhone=res.data.comoanyPhone
                this.form.workingYearName=res.data.workingYearName
                this.form.monthlySalaryName=res.data.monthlySalaryName
                this.form.workingDaysName=res.data.workingDaysName
                this.form.idCardPositive=res.data.idCardPositive
                this.form.idCardReverse=res.data.idCardReverse
                this.form.faceUrl=res.data.faceUrl
                this.isloaded=true
            })
        },
        getimgurl(data){
            this.form.idCardPositive=data.idCardPositive;
            this.form.idCardReverse=data.idCardReverse
            this.form.faceUrl=data.faceUrl
        },
    }
}
</script>
<style  scoped>
.formbox{ padding:15px 0; margin-top: 10px;}
</style>